import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ProductCarousel } from '#app/components/product-carousel'
import { cn } from '#app/utils/misc'
import { type ClerkProduct } from '#types/product'

interface VisitorHistorySliderProps {
	className?: string
}

const ENDPOINT = 'visitor/history'
const VisitorHistorySlider = ({ className }: VisitorHistorySliderProps) => {
	const { t } = useTranslation('common')
	const [clerkProducts, setClerkProducts] = useState<
		ClerkProduct[] | undefined
	>(undefined)

	useEffect(() => {
		if (ENDPOINT) {
			const url = `/resources/productCarouselDataClerk?endpoint=${encodeURIComponent(
				ENDPOINT,
			)}`

			const fetchData = async () => {
				try {
					const response = await fetch(url)
					if (!response.ok) {
						throw new Error(
							`Network response was not ok: ${response.statusText}`,
						)
					}
					const data = await response.json()
					setClerkProducts(data)
				} catch (error) {
					console.error('Failed to fetch products:', error)
					setClerkProducts([])
				}
			}
			fetchData()
		} else {
			setClerkProducts([]) // Ensure clerk products are empty if no recommendation
		}
	}, [])

	if (clerkProducts?.length === 0) return

	return (
		<div className={cn('w-full', className)}>
			<div className="flex flex-col gap-y-8">
				<ProductCarousel
					clerkProducts={clerkProducts}
					commercetoolsProducts={undefined}
					title={t('visitor_history_clerk_slider_title')}
					subtitle={t('visitor_history_clerk_slider_subtitle')}
				/>
			</div>
		</div>
	)
}

export default VisitorHistorySlider
